import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import type { NavigationItem } from '../../types';

interface MobileNavItemProps {
  item: NavigationItem;
  onClick?: () => void;
}

export function MobileNavItem({ item, onClick }: MobileNavItemProps) {
  const location = useLocation();
  const isActive = location.pathname === item.href;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // If it's a hash link, handle smooth scrolling
    if (item.href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(item.href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Close mobile menu
    onClick?.();
  };

  return (
    <Link
      to={item.href}
      onClick={handleClick}
      className={`
        flex items-center gap-3 px-4 py-3 rounded-lg transition-colors
        ${isActive 
          ? 'bg-white/10 text-white' 
          : 'text-gray-300 hover:text-white hover:bg-white/5'
        }
      `}
    >
      <item.icon className="w-5 h-5 flex-shrink-0" />
      <div className="min-w-0">
        <div className="text-base font-medium">{item.label}</div>
        {item.description && (
          <div className="text-sm text-gray-400 line-clamp-2 mt-0.5">
            {item.description}
          </div>
        )}
      </div>
    </Link>
  );
}